import { OWNERSHIP_NOTICE } from "../../config/preview";

// Inline small grey footer note. Rendered inside Layout and inside Login
// so every screen carries the ownership notice while PAID = false.
export function PreviewFooter() {
  return (
    <footer
      data-testid="preview-footer"
      className="preview-footer text-[11px] text-slate-400 dark:text-slate-500 text-center px-6 py-5 leading-relaxed"
    >
      {OWNERSHIP_NOTICE}
    </footer>
  );
}
